import PartnersListItem from './classes/PartnersListItem.js';
import PartnersBroadcast from './classes/PartnersBroadcast.js';
import PartnersMix from './classes/PartnersMix.js';

const initPartnersList = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="partners-list"]'));

  elements.forEach((element) => {
    new PartnersListItem(element);
  });
};

const initPartnersBroadcast = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="partners-broadcast"]'));

  elements.forEach((element) => {
    new PartnersBroadcast(element);
  });
};

const initPartnersMix = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="partners-mix"]'));

  elements.forEach((element) => {
    new PartnersMix(element);
  });
};

export { initPartnersList, initPartnersBroadcast, initPartnersMix };
